var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Confirm, Dropdown, Label, Modal } from "semantic-ui-react";
import { deleteWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
var ScreeningOrganismsEditor = /** @class */ (function (_super) {
    __extends(ScreeningOrganismsEditor, _super);
    function ScreeningOrganismsEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.basePath = function () {
            return "/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.organismId) +
                ("/probe-set-families/id/" + encodeURIComponent(_this.props.probeSetFamilyId)) +
                ("/variants/id/" + encodeURIComponent(_this.props.variantId) + "/screening-organisms");
        };
        _this.addOrganism = function (organismId) {
            _this.setState({ saving: true }, function () {
                postJsonWithAuthn(_this.basePath(), JSON.stringify({ organismId: organismId }))
                    .then(function (resp) {
                    _this.setState({ saving: false, modalOpen: false, selectedOrganismId: undefined });
                    if (resp.ok) {
                        _this.props.onChange();
                    }
                    else {
                        console.error("Failed to add screening organism: " + resp.status);
                    }
                })
                    .catch(function (e) {
                    _this.setState({ saving: false });
                    console.error("Failed to add screening organism: " + e);
                });
            });
        };
        _this.removeOrganism = function (organismId) {
            _this.setState({ saving: true, confirmRemove: undefined }, function () {
                deleteWithAuthn(_this.basePath() + "/id/" + encodeURIComponent(organismId))
                    .then(function (resp) {
                    _this.setState({ saving: false });
                    if (resp.ok) {
                        _this.props.onChange();
                    }
                    else {
                        console.error("Failed to remove screening organism: " + resp.status);
                    }
                })
                    .catch(function (e) {
                    _this.setState({ saving: false });
                    console.error("Failed to remove screening organism: " + e);
                });
            });
        };
        _this.state = { modalOpen: false, saving: false };
        return _this;
    }
    ScreeningOrganismsEditor.prototype.render = function () {
        var _this = this;
        var _a;
        // Defensive: an older backend response can leave this undefined; guard so the editor (and its "+") still render.
        var screeningOrganisms = (_a = this.props.screeningOrganisms) !== null && _a !== void 0 ? _a : [];
        var addedIds = new Set(screeningOrganisms.map(function (o) { return o.id; }));
        var options = this.props.allOrganisms
            .filter(function (o) { return !addedIds.has(o.id); })
            .map(function (o) { return ({ key: o.id, value: o.id, text: o.name }); });
        return React.createElement("span", null,
            screeningOrganisms.length === 0 && React.createElement("em", null, "none "),
            screeningOrganisms.map(function (o) {
                return React.createElement(Label, { key: o.id, size: 'mini', content: o.name, onRemove: function () { return _this.setState({ confirmRemove: o }); } });
            }),
            React.createElement(Button, { size: 'mini', icon: 'plus', title: 'Add screening organism', onClick: function () { return _this.setState({ modalOpen: true, selectedOrganismId: undefined }); } }),
            React.createElement(Modal, { open: this.state.modalOpen, size: 'tiny', closeIcon: true, onClose: function () { return _this.setState({ modalOpen: false }); } },
                React.createElement(Modal.Header, null, "Add screening organism"),
                React.createElement(Modal.Content, null,
                    React.createElement(Dropdown, { fluid: true, search: true, selection: true, options: options, placeholder: 'Search organisms…', value: this.state.selectedOrganismId, onChange: function (_, data) {
                            if (typeof data.value === 'number') {
                                _this.setState({ selectedOrganismId: data.value });
                            }
                        } })),
                React.createElement(Modal.Actions, null,
                    React.createElement(Button, { onClick: function () { return _this.setState({ modalOpen: false }); } }, "Cancel"),
                    React.createElement(Button, { primary: true, disabled: this.state.selectedOrganismId === undefined || this.state.saving, loading: this.state.saving, onClick: function () {
                            if (_this.state.selectedOrganismId !== undefined) {
                                _this.addOrganism(_this.state.selectedOrganismId);
                            }
                        } }, "Add"))),
            React.createElement(Confirm, { open: this.state.confirmRemove !== undefined, content: this.state.confirmRemove
                    ? "Remove " + this.state.confirmRemove.name + " as a screening organism?"
                    : '', onCancel: function () { return _this.setState({ confirmRemove: undefined }); }, onConfirm: function () {
                    if (_this.state.confirmRemove) {
                        _this.removeOrganism(_this.state.confirmRemove.id);
                    }
                } }));
    };
    return ScreeningOrganismsEditor;
}(React.Component));
export default ScreeningOrganismsEditor;
//# sourceMappingURL=ScreeningOrganismsEditor.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ScreeningOrganismsEditor.js
// module id = 1464
// module chunks = 0